import * as vp from 'vopay';
import { FunctionComponent, memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Mastercard.module.scss';

type MastercardProps = {
  iFrameUrl: string;
};

type FC = FunctionComponent<MastercardProps>;

export const MastercardP2C: FC = memo((props: MastercardProps) => {
  const { iFrameUrl } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'DebitCardForm' });
  const iFrameRef = useRef<HTMLIFrameElement | null>(null);

  return (
    <div>
      <vp.Box flx="col" width="50%">
        <vp.Box mb="md" flx="col" height="auto">
          <vp.Title title={`${t('title')}`} size="lg" bold />
        </vp.Box>
        <iframe
          id="myIframe"
          name="mastercard"
          title="Mastercard"
          className={styles.MastercardIFrame}
          src={iFrameUrl}
          ref={iFrameRef}
        />
      </vp.Box>
    </div>
  );
});
